module.exports = __webpack_public_path__ + "img/3.0afada3.png";